<template>
	<div>
		<PageHeaderLayout>
			<el-button type="" style="margin-bottom: 10px;" @click="goBack()"  icon="el-icon-back" size="medium">
				返回
			</el-button>
			<div class="main-page-content"
				v-loading="loadingStaus"
				:element-loading-text="loadingText">
				<el-row :gutter="48">
					<el-form ref="companyForm" :model="formData" :rules="rules" label-width="100px">
						<el-col :span="18">
							<el-form-item label="公司名称" prop="company_name">
								<el-input v-model="formData.company_name"></el-input>
							</el-form-item>
							<el-form-item :label="project_status?'企业联系人手机号':'企业负责人手机号'" prop="phone">
								<el-input type="input" v-model="formData.contact_phone"></el-input>
							</el-form-item>
							<el-form-item label="企业税号" v-if="!project_status" prop="number">
								<el-input type="input" v-model="formData.taxpayer"></el-input>
							</el-form-item>
							<el-form-item label="企业资质:">
								<el-form-item label="营业执照" prop="image">
									<img class="idImg" :src="formData.business_license" @click="showImage(formData.business_license)"/>
								</el-form-item>
								<el-form-item label="企业授权书" prop="image1">
									<div v-for="(item, index) in formData.authorization" v-bind:key="index">
										<img class="idImg" :src="item" @click="showImage(item)"/>
									</div>
								</el-form-item>
							</el-form-item>
							<el-form-item label="公司主营业务" v-if="project_status" prop="address">
								<el-input type="textarea" rows="8" v-model="formData.desc"></el-input>
							</el-form-item>
							<el-form-item :label="project_status?'公司业务地区':'可承接地区'" prop="address">
								<el-input type="input" v-model="formData.address"></el-input>
							</el-form-item>
							<el-form-item v-if="!project_status" label="可承接业务范围和项目经验" prop="content">
								<el-input type="textarea" rows="8" v-model="formData.desc"></el-input>
							</el-form-item>
						</el-col>
					</el-form>
				</el-row>
				<!-- 预览图片弹框 -->
				<el-dialog 
					:title="'预览图片'"
					:visible.sync="dialogVisible" 
					:modal="false"
					:width="'25%'"
				>
					<div class="block" v-if="dialogVisible">
						<img :src="this.imageUrl" class="preview">
					</div>
				</el-dialog>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadFile from "@/components/UploadFile";
import { mapGetters } from 'vuex'

export default {
	components: {
		PageHeaderLayout,
		UploadFile,
	},
	data() {
		return {
			dialogVisible: false,
			activeTab: '0',
			hearTitle: '基本设置',
			loadingStaus: true,
			loadingText: '正在提交中……',
			formDisabled: false,
			billId:0, // 公司id，0表示创建，非零为编辑
			// element的cascader的props值
			cascaderProps:{
				label:'display_name',
				value:'id',
			},
			// 分类列表
			categoryList:[],
			openapiList:[],
			// 标签
			categoryLabelList:[],
			// 已选中的分类列表，用于cascader组件选中效果
			selectedList:[],
			// 已选中标签
			selectedLabelList:[],
			// 公司基本信息表单结构
			formData:{},
			// 已上传图片列表
			uploadFileList:[],
			// 公司基本信息规则
			rules: {
				name: [
					{required: true, message: '输入公司名称', trigger: 'blur' },
				],
				file_url: [
					{required: true, message: '输入文件名称', trigger: 'blur' },
				]
			},
			// 附件类型
			attachmentType:['application/pdf','application/caj','','application/zip','application/rar','application/doc'],
			// 已上传附件列表
			attachmentUploadFileList:[],
			imageUrl: '',//图片地址
			project_status:this.$route.query.project_status,
			company_id:this.$route.query.id
		}
	},
	computed: {
		...mapGetters(['userPermissions']),
	},
	methods: {
		/* 预览图片 */
		showImage(data) {
			this.dialogVisible = true;
			this.imageUrl = data;
		},
		// 返回列表
		returnList() {
			this.$router.push('/bill')
		},
		// 菜单选择
		categoryChange(v) {
			console.log("categoryChange", v)
			if (v) {
				this.formData.parent_id = v
			}
		},
		openapiChange(v) {
			console.log("openapiChange", v)
			if (v) {
				this.formData.openapi_id = v
			}
		},
		// 级联菜单组件change事件
		cascaderLabelChange(v) {
			if (v.length) {
				this.formData.category_2_id = v[(v.length-1)]
				this.formData.category_2_ids = v
			} else {
				this.formData.category_2_id = ''
				this.formData.category_2_ids = []
			}
		},
		// 级联菜单自定义验证，选择分类
		cascaderVerify(rule, value, callback) {
			if (rule.required && !this.selectedList.length) {
				callback(new Error(rule.message))
			}
			callback()
		},
		// 确认保存按钮
		async saveConfirm() {
			// 调用组件的数据验证方法
			this.$refs['companyForm'].validate((valid) => {
				if (valid) {
					this.formSubmit()
				} else {
					this.$message.error('数据验证失败，请检查必填项数据！')
				}
			})
			return true
		},
		// 公司相关信息的保存处理
		async formSubmit() {
			this.loadingStaus = true
			try {
				let id = await this.$api.saveBill(this.formData)
				if (id.length > 0) {
					this.$notify.success('保存成功！')
					if (this.billId === 0 && id) {
						this.$router.push(this.$route.matched[1].path)
					}
				}
				this.$nextTick(() => {
					this.loadingStaus = false
				})
			} catch(err) {
				console.log('err is ->', err)
			}
		},
		// 初始化公司基本信息
		async init() {
			if(this.company_id) {
				this.formData = {};
				if(this.project_status) {
					let info = await this.$api.viewPaihuoEmployment(this.company_id)
					info.address = "";
					info.locations.forEach(function(item){
						if(info.address=="") {
							info.address = item.address;
						} else {
							info.address = info.address+";"+item.address;
						}
					})
					this.formData = info
				} else {
					let data = await this.$api.viewPaihuoHumanResources(this.company_id)
					data.address = "";
					data.locations.forEach(function(item){
						if(data.address=="") {
							data.address = item.address;
						} else {
							data.address = data.address+";"+item.address;
						}
					})
					this.formData = data
				}
			}
		},
		//返回上一页
		goBack() {
			this.$router.push({ path: "/paihuo",query:{project_status:this.project_status}});
		}
	},
	async mounted() {
		this.loadingStaus = true
		this.init()
		this.$nextTick(() => {
			this.loadingStaus = false
		})
		if(this.$config.domain.ename === 'opryousuiyun') {
			this.is_ysy = true;
		}
	},
}
</script>

<style lang="stylus" scoped>
  .content-left
    min-height 640px
    border-right 1px solid  #e8e8e8
    .el-cascader
      display block
      width 320px
  .back-btn
    position absolute;
    right 50px;
    top 150px;
  .content-right
    .right-button
      border-top 1px solid #e8e8e8e8
      padding 12px 12px
    .el-form-item__label
      float none
      display inline-block
      text-align left
      padding 0 0 10px 0
    .el-form-item__content
      margin-left 0px !important
      .el-checkbox-group
        margin-top -12px
  .preview
    width: 100%	
  .idImg
    width: 100px
    cursor: pointer
</style>
